<template>
	<div>
		<app-header @logout="logoutUser" v-if="isUserLocationSet"></app-header>

		<div class="section">
	        <div class="container">
				<transition name="fade" mode="out-in">
					<router-view></router-view>
				</transition>
	        </div>

			<app-footer v-if="isUserLocationSet"></app-footer>
	    </div>

		<app-login :isOpenModal="showLoginModal"></app-login>
		<app-signup :isOpenModal="showSignupModal"></app-signup>
		<app-reset :isOpenModal="showResetModal"></app-reset>
		<app-loader v-show="showLoader"></app-loader>
		<mobile-basket v-show="showMobileBasket"></mobile-basket>
	</div>
</template>

<script>
	import Layouts from './components/layouts';
	import AppLogin from './components/auth/Login';
	import AppSignup from './components/auth/Signup';
	import AppReset from './components/auth/ResetModal';
	import MobileBasket from './components/partials/FloatingBasket';
	import { mapGetters, mapActions } from 'vuex';

	export default {
		components: {
			...Layouts,
			AppLogin,
			AppSignup,
			AppReset,
			MobileBasket
		},

		data() {
			return {
				isMobile: false
			};
		},

		computed: {
			...mapGetters({
				isUserLoggedIn: 'User/isLoggedIn', 
				isUserLocationSet: 'User/isLocationSet', 
				getUser: 'User/getUser',
				showLoader: 'showLoaderStatus',
                showLoginModal: 'User/shouldShowLogin',
                showSignupModal: 'User/shouldShowSignup',
                showResetModal: 'User/shouldShowReset',
                basketCount: 'Basket/getCount'
			}),

			/**
			 * Determine if the mobile basket should be shown.
			 * 
			 * @return {Boolean}
			 */
			showMobileBasket() {
				// Don't show floating basket on these pages
				const excludedRoutes = [
					'location', 'checkout', 'basket', 'awaiting_payment',
				];

				return this.isMobile && this.basketCount && excludedRoutes.indexOf(this.$route.name) === -1;
			}
		},

		methods: {
			...mapActions({
				logout: 'User/logout',
			}),

			/**
			 * Logout the user.
			 * When the current page is the my account page, 
			 * redirect to the home page.
			 * 
			 * @return null
			 */
			logoutUser() {
				this.logout();
				this.notify({
					message: 'You have successfully logged out. Come back soon.',
					type: 'success'
				});

				if (this.$route.name === 'my_account') {
					this.$router.push({ name: 'home' });
				}
			},

			/**
			 * Check if the screen size or device falls into the 
			 * mobile category. This helps in showing the bottom 
			 * basket.
			 *
			 * @return {Undefined}
			 */
			checkForMobile() {
				this.isMobile = $(window).width() < 769;
			}
		},

		mounted() {
			this.checkForMobile();

			$(window).on('resize', this.checkForMobile);
		}
	}
</script>

<style scoped>
	.fade-enter-active, .fade-leave-active {
	  transition: opacity .3s
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
	  opacity: 0
	}

	.container {
		min-height: 84.4vh;
	}

	.section {
		padding-bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// App.vue?4ae9e344